<template>
    <Modal title="Modificar Usuario" v-model="usuario.editar" :enableClose="false" :modal-style="{'min-width': '300px', 'max-width': '1140px'}">
        <div class="vm-content">
            <CRow>
                <CCol col="7">
                    <CInput
                        label="Nombre Usuario"
                        v-model="usuario.userName"
                        type="text"
                        horizontal
                        placeholder="Nombre Usuario"
                    />
                    
                    <CInput
                        label="Nombre"
                        v-model="usuario.nombreUsuario"
                        type="text"
                        horizontal
                        placeholder="Nombre"
                    />
                    <CInput
                        label="Apellido"
                        v-model="usuario.apellidoUsuario"
                        type="text"
                        horizontal
                        placeholder="Apellido"
                    />
                    <CInput
                        label="Correo"
                        v-model="usuario.mailUsuario"
                        type="text"
                        horizontal
                        placeholder="Correo"
                        :is-valid="usuario.mailValidoUser"
                        @blur="validarCampos()"
                    />
                </CCol>
                <CCol col="5">
                    <div v-tippy="getBaseTippy('El usuario esta habilitado/Deshabilitado para acceder a Gesto')">
                        <CSwitch
                            width="150px"
                            class="mx-1 align-middle mb-2" 
                            color="success" 
                            shape="pill"
                            variant="outline"
                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                            :checked="usuario.habilitado"
                            @update:checked="usuario.habilitado = !usuario.habilitado"
                        /> Usuario Habilitado Gesto
                    </div>
                    
                    <div v-tippy="getBaseTippy('Si esta opción está activada significa que el usuario está eliminado para el cliente (no se elimina del todo de nuestro sistema y lo podemos recuperar)')">
                        <CSwitch
                            width="150px"
                            class="mx-1 align-middle mb-2" 
                            color="success" 
                            shape="pill"
                            variant="outline"
                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                            :checked="usuario.usuarioEliminado"
                            @update:checked="usuario.usuarioEliminado = !usuario.usuarioEliminado"
                        /> Usuario Eliminado Gesto
                    </div>
                    <hr>
                    <span v-tippy="getBaseTippy('Tipo de Usuario para Gesto')">
                        <div>
                            <CSwitch
                                width="150px"
                                class="mx-1 align-middle mb-2" 
                                color="success" 
                                shape="pill"
                                variant="outline"
                                v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                :checked="usuario.usuarioAdmin"
                                @update:checked="usuario.usuarioAdmin = !usuario.usuarioAdmin; validarTipoUsuarioEdit('admin',usuario.usuarioAdmin,usuario)"
                            /> Admin
                        </div>
                        <div>
                            <CSwitch
                                width="150px"
                                class="mx-1 align-middle mb-2" 
                                color="success" 
                                shape="pill"
                                variant="outline"
                                v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                :checked="usuario.usuarioNormal"
                                @update:checked="usuario.usuarioNormal = !usuario.usuarioNormal; validarTipoUsuarioEdit('normal',usuario.usuarioNormal,usuario)"
                            /> Normal
                        </div>
                        <div>
                            <CSwitch
                                :disabled="!cliente.habilitadoPortalEmpresa"
                                width="150px"
                                class="mx-1 align-middle mb-2" 
                                color="success" 
                                shape="pill"
                                variant="outline"
                                v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                :checked="usuario.usuarioRevision"
                                @update:checked="usuario.usuarioRevision = !usuario.usuarioRevision; validarTipoUsuarioEdit('revision',usuario.usuarioRevision, usuario)"
                            />
                            <span v-if="!cliente.habilitarCompartida" v-tippy="getBaseTippy('Esta opcion está deshabilitada ya que el cliente no tiene habilitada la opcion Portal Empresa')">
                                <CIcon name="cil-bell-exclamation" size="lg" class="mr-1" style="color:brown" />
                            </span>
                            Revision
                        </div>
                    </span>
                    <hr>

                    <div>
                        <CSwitch
                            :disabled="!cliente.habilitarCompartida"
                            class="mx-1 align-middle mb-2"
                            v-tippy="getBaseTippy('Deshabilitar/Habilitar Compartida archivos, está opcion es independiente de gesto, aunque este deshabilitado o eliminado el usuario (esto tengo pensado sacarlo de gesto y llevarlo independiente)')"
                            width="150px"
                            color="success" 
                            shape="pill"
                            variant="outline"
                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                            :checked="usuario.habilitadoCompartir"
                            @update:checked="usuario.habilitadoCompartir = !usuario.habilitadoCompartir"
                        /> 
                        <span v-if="!cliente.habilitarCompartida" v-tippy="getBaseTippy('Esta opcion está deshabilitada ya que el cliente no tiene habilitada la opcion compartia')">
                            <CIcon name="cil-bell-exclamation" size="lg" class="mr-1" style="color:brown" />
                        </span>
                        Habilitar Compartir
                    </div>

                </CCol>
            </CRow>                                                                   
            
            
        </div>
        <div class="vm-footer">
            
            <CButtonGroup class="mx-1" v-show="usuario.editar && !usuario.eliminar">
                <CButton color="success" size="sm"
                    v-tippy="getBaseTippy('Aceptar Cambios')"
                    :disabled="isModificando || !usuario.rutValidadoUser 
                    || !usuario.mailValidoUser 
                    || !usuario.userName.length>0
                    || !usuario.nombreUsuario.length>0
                    || !usuario.apellidoUsuario.length>0"
                    @click="guardarEdicionUsuario(usuario)">
                    <CIcon name="cil-check-circle"/><!-- Aceptar-->
                </CButton>
                <CButton color="danger" size="sm"
                    :disabled="isModificando"
                    v-tippy="getBaseTippy('Cancelar Cambios')"
                    @click="usuario.editar=false; cancelarEdicion(usuario)">
                    <CIcon name="cil-x-circle"/>
                </CButton>
                <CButton color="warning" size="sm" v-show="isModificando">
                    <CIcon :content="$options.freeSet.cilLoopCircular" class="imgr" />
                </CButton>
            </CButtonGroup>
        </div>
    </Modal>
</template>

<script>

    import cons from "@/const";
    
    import axios from "axios";
    import VueModal from "@kouts/vue-modal";
    import "@kouts/vue-modal/dist/vue-modal.css";
    
    import { freeSet } from "@coreui/icons";
    import { CCol } from "@coreui/vue";

    export default {
        name: "EditarUsuario",
        freeSet,
        props: {
            cliente: Object,
            usuario: Object
        },
        components: {
            Modal: VueModal,
        },
        data() {
            return {
                tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin")).tokenUsuario,
                baseUrl: cons.protocolo+"://" + cons.ipServer + cons.puerto,
                regMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,

                isModificando: false,

                modificarVariablesDrive: false,
                modificarIdUnidad: false,
                modificarNombreUnidadDrive: false,
                modificarCarpetaDriveDefecto: false
            }
        },
        created: function () {},
        beforeMount() {
        },
        mounted() {},
        methods: {
            /*guardarEdicionCliente: function(){
                this.isModificando = true
                let clienteMod = {
                    idCliente: this.cliente.idCliente,
                    nombreCliente: this.cliente.nombreCliente,
                    rutEmpresa: this.cliente.rutEmpresa,
                    rutaCarpetaBd: this.cliente.rutaCarpetaBd,
                    idUnidadDrive: this.cliente.idUnidadDrive,
                    habilitado: this.cliente.habilitado,
                    habilitadoGesto: this.cliente.habilitarGesto,
                    habilitadoCompartida: this.cliente.habilitarCompartida,
                    rutaCarpetaDrive: this.cliente.rutaCarpetaDrive,
                    carpetaDefectoDrive: this.cliente.carpetaDefectoDrive,
                    habilitadoPortalEmpresa: this.cliente.habilitadoPortalEmpresa,
                    carpetaRaiz: this.cliente.carpetaRaiz,
                    tipoBdRemu: this.cliente.tipoBdRemu,
                    tipoBdConta: this.cliente.tipoBdConta
                }
                var url = this.baseUrl + "/modificar_cliente/";
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "clienteData": clienteMod
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    this.mostrarNotificaciones2(4, "Notificación!", result.data, 'bottom-center')
                    //this.mostrarNotificaciones(1, result.data)
                    //this.$notification.success(result.data, {  timer: 10, position:"bottomRight"});
                    
                    //this.cliente.editar = false
                    
                }, error => {
                        let mensaje = `Problema al modificar Cliente, ${error}`
                        this.mostrarNotificaciones(2, error.response.data)
                       
                })
                .finally(() => {
                    this.isModificando = false
                });
            },*/
            cancelarEdicion: function(){
                //this.$emit("cancelarEdicion")
                
                //this.usuario = JSON.parse(JSON.stringify(this.usuario.respaldoUser))
                this.usuario.apellidoUsuario = this.usuario.respaldoUser.apellidoUsuario;
                //this.usuario.editar = this.usuario.respaldoUser.editar;
                //this.usuario.eliminar = this.usuario.respaldoUser.eliminar;
                this.usuario.habilitado = this.usuario.respaldoUser.habilitado;
                this.usuario.habilitadoCompartir = this.usuario.respaldoUser.habilitadoCompartir;
                //this.usuario.idCliente = this.usuario.respaldoUser.idCliente;
                //this.usuario.idUsuario = this.usuario.respaldoUser.idUsuario;
                this.usuario.mailUsuario = this.usuario.respaldoUser.mailUsuario;
                //this.usuario.mailValidoUser = this.usuario.respaldoUser.mailValidoUser;
                this.usuario.nombreUsuario = this.usuario.respaldoUser.nombreUsuario;
                this.usuario.rutUsuario = this.usuario.respaldoUser.rutUsuario;
                //this.usuario.rutValidadoUser = this.usuario.respaldoUser.rutValidadoUser;
                this.usuario.sueldoEmpresarial = this.usuario.respaldoUser.sueldoEmpresarial;
                this.usuario.userName = this.usuario.respaldoUser.userName;
                this.usuario.usuarioAdmin = this.usuario.respaldoUser.usuarioAdmin;
                this.usuario.usuarioEliminado = this.usuario.respaldoUser.usuarioEliminado;
                this.usuario.usuarioNormal = this.usuario.respaldoUser.usuarioNormal;
                this.usuario.usuarioRevision = this.usuario.respaldoUser.usuarioRevision;
                

            },

            guardarEdicionUsuario: function(){
                this.isModificando = true
                var url = this.baseUrl + "/modificar_usuario_cliente/";

                var cambioCompartir = this.usuario.respaldoUser.habilitadoCompartir != this.usuario.habilitadoCompartir
                
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "usuarioData": {
                            "usuario": this.usuario,
                            "cambioCompartir": cambioCompartir,
                            "cambioCorreo": this.usuario.respaldoUser.mailUsuario != this.usuario.mailUsuario,
                            "mailAnterior": this.usuario.respaldoUser.mailUsuario,
                            "mailNuevo": this.usuario.mailUsuario
                        }
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    this.mostrarNotificaciones2(4, "Yujuuu!", result.data, 'bottom-center')
                    //this.usuario.editar = false
                }, error => {
                        this.mostrarNotificaciones2(4, "Ups!!", error.response.data, 'bottom-center')
                })
                .finally(() => {
                    this.isModificando = false
                });

            },
            
            eliminarUsuarioCliente: function(){
                var url = this.baseUrl + "/eliminar_usuario_cliente/";

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "idUsuarioCliente": this.usuario.idUsuario
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    this.$notification.success(result.data, {  timer: 10, position:"bottomRight"});
                    this.usuario.usuarioEliminado = true
                    this.usuario.eliminar = false
                }, error => {
                        let mensaje = `Problema al obtener Clientes, ${error}`
                        this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight"});
                })
                .finally(() => {
                });
            },
            
            validarCampos: function(){

                if(this.usuario.mailUsuario == "" || this.usuario.mailUsuario == null){
                    this.usuario.mailValidoUser = false
                } else{
                    this.usuario.mailValidoUser =  this.regMail.test(this.usuario.mailUsuario)
                }

            },
            validarTipoUsuarioEdit: function(tipoUsuario,valor){
                if(tipoUsuario == "normal"){
                    if(valor){
                        this.usuario.usuarioAdmin = false
                        this.usuario.usuarioRevision = false
                    }
                }
                if(tipoUsuario == "admin"){
                     if(valor){
                        this.usuario.usuarioNormal = false
                        this.usuario.usuarioRevision = false
                     }
                }
                if(tipoUsuario == "revision"){
                    if(valor){
                        this.usuario.usuarioAdmin = false
                        this.usuario.usuarioNormal = false
                    }
                }

            },
            
        }
    }
</script>